// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { checkoutGridProps } from "@store/Themes/common/props/checkout";
import React from "react";
import { css } from "styled-components";

interface Props {
    id: string;
    extendedStyles?: StoreCheckoutPageContainerStyles;
}

export interface StoreCheckoutPageContainerStyles {
    pageWrapper?: InjectableCss;
    gridContainer?: GridContainerProps;
    mainGridItem?: GridItemProps;
    sideGridItemMobile?: GridItemProps;
    sideGridItemDesktop?: GridItemProps;
}

export const storeCheckoutPageContainerStyles: StoreCheckoutPageContainerStyles = {
    pageWrapper: {},
    gridContainer: {
        ...checkoutGridProps.container,
        offsetCss: css`
            justify-content: space-between;

            @media print {
                display: flex !important;
                flex-direction: column-reverse !important;
            }
        `,
    },
    mainGridItem: checkoutGridProps.mainColumn,
    sideGridItemMobile: checkoutGridProps.sideColumnMobile,
    sideGridItemDesktop: checkoutGridProps.sideColumnDesktop,
};

const StoreCheckoutPageContainer = ({ id, extendedStyles }: Props) => {
    const [styles] = React.useState(() => mergeToNew(storeCheckoutPageContainerStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.pageWrapper}>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.sideGridItemMobile}>
                    <Zone zoneName="Content1" contentId={id} />
                </GridItem>
                <GridItem {...styles.mainGridItem}>
                    <Zone zoneName="Content2" contentId={id} />
                </GridItem>
                <GridItem {...styles.sideGridItemDesktop}>
                    <Zone zoneName="Content1" contentId={id} />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default StoreCheckoutPageContainer;
